import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_SAFETY_ACCESS: MijnRoute = {
    path: 'veiligheid-en-toegang',
    navigationEvent: 'toVeiligheidEnToegang',
    regex: /^\/zelf-regelen\/veiligheid-en-toegang$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/veiligheid-en-toegang'
};
